document.querySelectorAll('[data-product-faq-ask-toggle]').forEach((button) => {
  const target = document.getElementById(button.getAttribute('aria-controls'));
  if (!target) return;

  if (!target.hasAttribute('hidden')) {
    button.setAttribute('aria-expanded', 'true');
  }

  button.addEventListener('click', () => {
    const isHidden = target.hasAttribute('hidden');
    if (isHidden) {
      target.removeAttribute('hidden');
    } else {
      target.setAttribute('hidden', '');
    }
    button.setAttribute('aria-expanded', String(isHidden));
  });
});
